import React from "react";
import PropTypes from "prop-types";
import LossToActionOverview from "../../LossToActionOverview";
const UnloadingPriorityGlobalOverview = ({
  data,
  columns,
  paginationData,
  sortingData,
  handlePageChange,
  isLoading = false,
}) => {
  const scrollableColumnsArray = [
    "Shipment Details",
    "Order Loss Impact Packs",
    "Order Loss Mitigation",
    "% Order Loss Mitigation",
    "Overall Loss Mitigation",
    "% Overall Loss Mitigation",
    "MSTN Loss Impacted Packs",
    "Physical MSTN Loss Mitigation",
    "% Physical MSTN Loss Mitigation",
    "Time Boundness of Mitigation",
    "Day wise Value Mitigation",
    "Order Loss Details",
  ];
  return (
    <LossToActionOverview
      data={data}
      columns={columns}
      paginationData={paginationData}
      sortingData={sortingData}
      handlePageChange={handlePageChange}
      isLoading={isLoading}
      scrollableColumnsArray={scrollableColumnsArray}
      totalColumnName="Shipment number"
      fixedColumnName="Truck details"
      tableType="Unloading Priority"
    />
  );
};

UnloadingPriorityGlobalOverview.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  paginationData: PropTypes.shape({
    page: PropTypes.number,
    rowsPerPage: PropTypes.number,
    totalRecords: PropTypes.number,
  }),
  sortingData: PropTypes.shape({
    sortBy: PropTypes.string,
    sortOrder: PropTypes.string,
  }),
  handlePageChange: PropTypes.func,
  isLoading: PropTypes.bool,
};

UnloadingPriorityGlobalOverview.defaultProps = {
  isLoading: false,
  paginationData: {},
  sortingData: {},
  handlePageChange: null,
};

export default UnloadingPriorityGlobalOverview;
